'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var styleHelper = require('../../helper/styleHelper.js');
var appTypes = require('../../types/appTypes');
var graphicsHelper = require('./../../helper/graphicsHelper');
var propConst = require('../../constants/propConst');
var VerticalScrollBar = require('../common/VerticalScrollBar');
var HorizontalScrollBar = require('../common/HorizontalScrollBar');
var TextParts = require('../common/TextParts');
var util = require('../../helper/util');
var _ = require('underscore');

var Shape = React.createClass({

  getInitialState: function () {
    return {};
  },

  paint: function (props) {
    var color = styleHelper.getBackgroundColor(this.props);
    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
    var w = canvas.clientWidth;//styleHelper.getWidth(this.props);
    var h = canvas.clientHeight;//styleHelper.getHeight(this.props);
    var radius = styleHelper.getRadius(this.props);
    var dashMode = styleHelper.parseDashMode(styleHelper.getPropertyValue(this.props,propConst.DASH_MODE));
    //todo :PC上的形状的三角形的旋转方向居然与其它的旋转方向是相反的！！！
    var triangleType = this.props.triangleType;
    if(triangleType === appTypes.RotationAngle.NINETY){
      triangleType = appTypes.RotationAngle.TWO_HUNDRED_SEVENTY;
    }else if(triangleType === appTypes.RotationAngle.TWO_HUNDRED_SEVENTY){
      triangleType = appTypes.RotationAngle.NINETY;
    }
    canvas.width = w;
    canvas.height = h;
    graphicsHelper.drawShpae(canvas.getContext('2d'),
      {
        width: w,
        height: h,
        dashMode : dashMode,
        borderType: this.props.shapeBorderType,
        borderVisible: styleHelper.getPropertyValue(this.props,propConst.BORDER_VISIBLE),
        borderColor: styleHelper.getBorderColor(this.props),
        fillColor: color,
        radius: radius,
        borderWidth: styleHelper.getBorderWidth(this.props),
        triangleType: triangleType,
        borderLeft: this.props.rectangleBorderLeftVisible,
        borderTop: this.props.rectangleBorderTopVisible,
        borderRight: this.props.rectangleBorderRightVisible,
        borderBottom: this.props.rectangleBorderBottomVisible
      });
  },

  doAdjustLinkArea: function () {
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var plink = $('#' + this.props.controlID + ' .page-link');
    var interactiveLink = $('#' + this.props.controlID + ' .interactive-link');

    if (plink) {
      plink.css({
        width: w,
        height: h
      });
    }
    if (interactiveLink) {
      interactiveLink.css({
        width: w,
        height: h
      });
    }

  },

  componentDidUpdate: function (props) {
    this.paint(props);
    this.doAdjustLinkArea();
  },
  componentDidMount: function (props) {
    this.paint(props);
    $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_PROPS_CHANGE, this.onPropsChange).on(appTypes.CUSTOM_EVENT.ON_RESIZE,this.onResize);
  },

  onResize : function(){
    $(ReactDOM.findDOMNode(this.refs.text)).trigger(appTypes.CUSTOM_EVENT.ON_PAINT,[this.props.controlID]);
    this.paint(this.props);
  },

  onPropsChange: function (propName, propValue) {
    var o = {};
    o[propName] = propValue;
    this.setState(o);
  },

  render: function () {
    var text = styleHelper.getText(this.props);
    this.currentW = styleHelper.getWidth(this.props);
    this.currentH = styleHelper.getHeight(this.props);
    var isShowScrollBar = (this.props.shapeBorderType === appTypes.ShapeType.RECTANGLE) && (this.props.verticalScrollbarShow || this.props.horizontalScrollbarShow);
    var verticalScrollBarHeight;
    var horizontalScrollBarWidth;
    var thickness = styleHelper.getBorderWidth(this.props);
    if (text) {
      var textArray = util.Text.delimitToParagraphs(text);
      this.isMultiLineText = textArray.length > 1;
    }
    if (isShowScrollBar) {
      if (this.props.verticalScrollbarShow && this.props.horizontalScrollbarShow) {
        verticalScrollBarHeight = this.currentH - 12 - 2 * thickness - 4;
        horizontalScrollBarWidth = this.currentW - 12 - 2 * thickness - 4;
      }
    }
    return (<div
      id={this.props.id}
      style={{
        position : 'absolute',
        width : '100%',
        height : '100%',
        left : 0,
        top : 0,
        overflow:'hidden'
      }}
      key={this.props.controlID + '-shape'}>
      <canvas
        ref="canvas"
        style={{
          position: 'absolute',
          left :0,
          top : 0,
          width : '100%',
          height : '100%',
          zIndex : -1
        }}
        onChange={this.paint.bind(this,this.props)}
        width={this.currentW}
        height={this.currentH}/>
      {
        text && <TextParts ref="text" zIndex={1} {...this.props}/>
      }
      {
        isShowScrollBar && this.props.horizontalScrollbarShow &&
        <HorizontalScrollBar
          value={util.Int(this.props.verticalScrollbarProgress)}
          width={horizontalScrollBarWidth}
        />
      }
      {
        isShowScrollBar && this.props.verticalScrollbarShow &&
        <VerticalScrollBar
          value={util.Int(this.props.verticalScrollbarProgress)}
          height={verticalScrollBarHeight}
        />
      }
    </div>);
  }
});

module.exports = Shape;



/** WEBPACK FOOTER **
 ** ./src/views/Components/Shape.jsx
 **/